import React from 'react'
import axios from 'axios';
import {connect} from 'react-redux'
import Select from 'react-select';
import Titulo from '../comum/Titulo';
import buscarCidades from '../../actions/cidade/buscarCidades';
import {PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoCidades from './PaginacaoCidades';
import BotoesPaginacaoCidades from './BotoesPaginacaoCidades';
import Cidade from './Cidade';
import {alterouPagina} from '../../util/filtros';
import ModalCadastrarCidade from './ModalCadastrarCidade';
import excluirCidade from '../../actions/cidade/excluirCidade';
import limparCidadeSelecionada from '../../actions/cidade/limparCidadeSelecionada';
import determinarPaginaAtualCidade from '../../actions/cidade/determinarPaginaAtualCidades';
import alterarRegistrosPorPaginaCidades from '../../actions/cidade/alterarRegistrosPorPaginaCidades';
import {estados} from '../../util/constantsUtil';
import {showSuccessMsg} from '../../util/messagesUtil';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {URL} from '../../util/ambienteActions';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-tabela-dados">
        <div className="row cabecalho-desktop">
            <div className="col-lg-2 col-xl-2">ID</div>
            <div className="col-lg-4 col-xl-4">Nome</div>
            <div className="col-lg-4 col-xl-4">Estado</div>
            <div className="col-lg-2 col-xl-2">Ações</div>
        </div>
    </div>
);

const ModalConfirmacaoExclusao = ({excluir, cidade}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoCidade" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir a cidade <strong>{cidade ? cidade.nomeComUf : ''}?</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal">Cancelar
                    </button>
                    <button id='excluir-cidade' type="button" className="btn btn-laranja float-left"
                            data-dismiss="modal"
                            onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelGerenciarCidades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            parametros: {
                id: '',
                nome: '',
                uf: ''
            }
        };
    }

    componentDidMount() {
        this.props.buscarCidades(this.state.parametros, this.props.paginaAtual, this.props.registrosPorPagina);
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps)) {
            this.props.buscarCidades(this.state.parametros, this.props.paginaAtual, this.props.registrosPorPagina);
        }
    }

    alterarParametro(tipo, valor) {
        const campos = {ESTADO: 'uf', NOME: 'nome', ID: 'id'};
        this.setState({
            parametros: {
                ...this.state.parametros,
                [campos[tipo]]: valor
            },
        })
    }

    buscar() {
        this.zerarPaginacao();
        this.props.buscarCidades(this.state.parametros, 1, 10);
    }

    handleChange(event) {
        this.alterarParametro('NOME', event.target.value)
    }

    exibirCampoBusca() {
        return (
            <div style={{display:'flex', gap:8, flexWrap:'wrap', alignItems:'center', marginBottom:12}}>
                <input className="form-control" type="text" inputMode="numeric" style={{height:38, maxWidth:140}}
                       placeholder="ID da Cidade" value={this.state.parametros.id}
                       onChange={e => this.alterarParametro('ID', e.target.value.replace(/\D/g, ''))}
                       onKeyPress={e => e.key === 'Enter' && this.buscar()}/>
                <div style={{minWidth:180, maxWidth:240}}>
                    <Select id="filtro-uf"
                            noOptionsMessage={() => ('Nenhuma opção encontrada')}
                            placeholder='Estado...'
                            options={estados.map(elemento => ({
                                label: elemento.nome,
                                value: elemento.uf
                            }))}
                            onChange={value => this.alterarParametro('ESTADO', value.value)}
                    />
                </div>
                <input className="form-control" type="text" style={{height:38, maxWidth:280}}
                       placeholder="Nome da Cidade" onChange={this.handleChange.bind(this)}/>
                <button onClick={() => this.buscar()} className="vx-toolbar-btn">
                    <i className="material-icons">search</i>
                    Buscar
                </button>
            </div>
        )
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoEmpresa() {
        return (
            <div className="vx-page-toolbar" style={{marginBottom:12}}>
                <span/>
                <div style={{display:'flex', gap:8}}>
                    <button className="vx-toolbar-btn vx-toolbar-btn--secondary"
                            onClick={() => this.exportarListaCidades()}>
                        <i className="material-icons">file_download</i>
                        Exportar
                    </button>
                    <button data-toggle="modal" data-target="#modalCadastrarCidade" className="vx-toolbar-btn"
                            onClick={() => this.props.limparCidadeSelecionada()}>
                        <i className="material-icons">add</i>
                        Nova Cidade
                    </button>
                </div>
            </div>)
    }

    async downloadParte(size, from) {
        const {id, nome, uf} = this.state.parametros;
        let url = `${URL}/public/cidades?size=${size}&from=${from}`;
        if (id) {
            url = `${url}&id=${id}`;
        }
        if (nome) {
            url = `${url}&nome=${encodeURIComponent(nome)}`;
        }
        if (uf) {
            url = `${url}&uf=${uf}`;
        }
        const retorno = await axios.get(url, SLOW_REQUEST_CONFIG);
        return retorno.data;
    }

    // eslint-disable-next-line class-methods-use-this
    executarDownload(arquivo) {
        const a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], {type: 'text/csv;'}));
        a.download = 'Lista de Cidades.csv';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async exportarListaCidades() {
        const size = 10000;
        const csv = valor => `"${(valor || '').toString().replace(/"/g, '""')}"`;
        let arquivo = 'ID Cidade;UF;Nome;Nome Normalizado\n';
        let from = 1;
        let total = 0;

        do {
            // eslint-disable-next-line no-await-in-loop
            const retorno = await this.downloadParte(size, from);
            total = retorno.total;
            arquivo = `${arquivo}${retorno.cidades.map(it =>
                `${it.id};${it.uf};${csv(it.nome)};${csv(it.nomeComUfNormalizado)}`).join('\n')}\n`;
            from += 1;
        } while ((from - 1) * size < total);

        this.executarDownload(arquivo);
    }

    exibir() {
        if (this.props.cidades && this.props.cidades.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoCidades}
                                       BotoesPaginacao={BotoesPaginacaoCidades}>
                    <CabecalhoTabela/>
                    <div className="lista-table">
                        {this.exibirCidades()}
                    </div>
                </CabecalhoRodapeTabela>
            )
        }
        return <div className="vx-empty-state"><i className="material-icons">location_city</i><p>Nenhuma cidade encontrada para os parâmetros informados.</p></div>;
    }

    exibirCidades() {
        if (this.props.cidades) {
            return this.props.cidades.map(cidade => <Cidade key={cidade.id} cidade={cidade}/>)
        }
    }

    zerarPaginacao() {
        this.props.determinarPaginaAtualCidade(1);
        this.props.alterarRegistrosPorPaginaCidades(10)
    }

    excluir() {
        this.props.excluirCidade(this.props.cidade.id).then(() => {
            showSuccessMsg('Cidade excluída com sucesso');
            this.buscar();
        })
    }


    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="container-padrao">
                    <Titulo texto="Gerenciar Cidades" urlRetorno="/"/>
                    <div className="vx-table-card">
                        {this.exibirCampoBusca()}
                        {this.exibirBotaoNovoEmpresa()}
                        {this.exibir()}
                    </div>
                </div>
                <ModalCadastrarCidade parametros={this.state.parametros}/>
                <ModalConfirmacaoExclusao excluir={this.excluir.bind(this)} cidade={this.props.cidade}/>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        cidades: state.cidades.cidades,
        paginaAtual: state.paginaAtualCidade,
        registrosPorPagina: state.registrosPorPaginaCidade,
        cidade: state.cidade
    });


export default connect(mapStateToProps, {
    buscarCidades,
    excluirCidade,
    limparCidadeSelecionada,
    determinarPaginaAtualCidade,
    alterarRegistrosPorPaginaCidades
})(PainelGerenciarCidades)
